import axios from "axios";

import { JsonResponse } from "core/models/response";
import { Country } from "core/models/countries";

export const onGetCountries = async () => {
	try {
		const response = await axios.get<JsonResponse<Country[]>>(`register/countries`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};